const STORAGE_PREFIX = 'ea-adm-list-filters:';

export function readSavedListFilters(pageKey) {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${pageKey}`);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function writeSavedListFilters(pageKey, filters) {
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${pageKey}`, JSON.stringify(filters));
  } catch {
    /* ignore quota / private mode */
  }
}

export function readSavedFilter(pageKey, key, fallback = '') {
  const saved = readSavedListFilters(pageKey);
  if (!saved || !(key in saved)) return fallback;
  return saved[key];
}

export function hasSavedFilter(pageKey, key) {
  const saved = readSavedListFilters(pageKey);
  return Boolean(saved && key in saved);
}

export function clearSavedListFilters(pageKey) {
  try {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${pageKey}`);
  } catch {
    /* ignore */
  }
}
